// HTML 엔티티 디코더 (PubMed 등이 특수문자를 &#x15b; 형태로 반환하는 경우 대응)
// 서버/클라이언트 양쪽에서 동작해야 하므로 정규식 기반으로 구현.

const NAMED_ENTITIES: Record<string, string> = {
  amp: "&",
  lt: "<",
  gt: ">",
  quot: '"',
  apos: "'",
  nbsp: " ",
};

export function decodeHtmlEntities(input: string | null | undefined): string {
  if (!input) return "";
  return input
    // &#x15b; → 유니코드 (16진수)
    .replace(/&#x([0-9a-fA-F]+);/g, (_, hex) => {
      const cp = parseInt(hex, 16);
      return Number.isFinite(cp) ? String.fromCodePoint(cp) : _;
    })
    // &#347; → 유니코드 (10진수)
    .replace(/&#(\d+);/g, (_, dec) => {
      const cp = parseInt(dec, 10);
      return Number.isFinite(cp) ? String.fromCodePoint(cp) : _;
    })
    // &amp; &lt; 등 명명된 엔티티
    .replace(/&([a-zA-Z]+);/g, (m, name) => NAMED_ENTITIES[name] ?? m);
}
